import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { 
  Card, 
  Checkbox, 
  Button, 
  Space, 
  Typography, 
  Row, 
  Col, 
  message,
  Divider
} from 'antd';
import { 
  SettingOutlined, 
  SaveOutlined, 
  CheckCircleOutlined,
  UserOutlined,
  TeamOutlined,
  AppstoreOutlined,
  EditOutlined,
  DeleteOutlined,
  BankOutlined
} from '@ant-design/icons';
import Api from "../../../../services/api";

const { Title, Text } = Typography;

function RolePermission() {
  const [loading, setLoading] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [rolePermission, setRolePermission] = useState([]);

  const { role } = useParams();

  const getRolePermission = () => {
    Api.get(`/api/role/${role}/permissions`)
      .then(response => {
        if (response?.data?.code == 0) {
          setRolePermission(response.data.data.map(i => i.code))
        }
      })
  }

  const handleRolePermission = (permissionCode, checked) => {
    let data = [...rolePermission];
    const index = data.indexOf(permissionCode);
    
    if (checked) {
      if (index === -1) {
        data.push(permissionCode);
      }
    } else {
      if (index > -1) {
        data.splice(index, 1);
      }
    }
    setRolePermission(data);
  }

  const savePermission = () => {
    setLoading(true);
    Api.put(`/api/role/${role}/permissions`, {
      permissions: rolePermission
    })
      .then(response => {
        setLoading(false);
        if (response?.data?.code == 0) {
          message.success('Cập nhật quyền role thành công!');
        } else {
          message.error('Có lỗi xảy ra!');
        }
      })
      .catch(error => {
        setLoading(false);
        message.error('Có lỗi xảy ra!');
      });
  }

  const getPermissionIcon = (permissionCode) => {
    switch (permissionCode) {
      case 'app.view':
        return <AppstoreOutlined style={{ color: '#1890ff' }} />;
      case 'user.create':
        return <UserOutlined style={{ color: '#52c41a' }} />;
      case 'user.edit':
        return <EditOutlined style={{ color: '#faad14' }} />;
      case 'user.delete':
        return <DeleteOutlined style={{ color: '#ff4d4f' }} />;
      case 'role.create':
        return <TeamOutlined style={{ color: '#722ed1' }} />;
      case 'role.edit':
        return <SettingOutlined style={{ color: '#fa8c16' }} />;
      case 'studio.create':
        return <BankOutlined style={{ color: '#13c2c2' }} />;
      case 'studio.edit':
        return <EditOutlined style={{ color: '#eb2f96' }} />;
      default:
        return <CheckCircleOutlined style={{ color: '#722ed1' }} />;
    }
  };

  useEffect(() => {
    Api.get('/api/me/permissions')
      .then(response => {
        if (response?.data?.code == 0) {
          setPermissions(response.data.data)
        }
      })
    getRolePermission()
  }, []);

  return (
    <div className="background-second-dashboard">
        <section className="main__content-dashbard">
          <div className="container-fluid">
          <Card>
            <Row justify="space-between" align="middle" style={{ marginBottom: '24px' }}>
              <Col>
                <Title level={4} style={{ margin: 0, fontSize: '18px' }}>
                  Phân quyền Role
                </Title>
              </Col>
              <Col>
                <Button 
                  type="primary" 
                  icon={<SaveOutlined />}
                  onClick={savePermission}
                  loading={loading}
                  size="small"
                >
                  Lưu quyền
                </Button>
              </Col>
            </Row>

            <Row gutter={[16, 16]}>
              {permissions.map(permission => {
                const hasPermission = rolePermission.indexOf(permission.code) > -1;
                
                return (
                  <Col xs={24} sm={12} md={8} lg={6} key={permission.id}>
                    <Card
                      size="small"
                      style={{
                        border: hasPermission ? '2px solid #52c41a' : '1px solid #d9d9d9',
                        borderRadius: '8px'
                      }}
                      bodyStyle={{ padding: '16px' }}
                    >
                      <Space direction="vertical" style={{ width: '100%' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <Space>
                            {getPermissionIcon(permission.code)}
                            <Text strong>{permission.name}</Text>
                          </Space>
                          <Checkbox
                            checked={hasPermission}
                            onChange={(e) => handleRolePermission(permission.code, e.target.checked)}
                          />
                        </div>
                        
                        {hasPermission && (
                          <div>
                            <Divider style={{ margin: '8px 0' }} />
                            <Space>
                              <CheckCircleOutlined style={{ color: '#52c41a' }} />
                              <Text type="secondary" style={{ fontSize: '12px' }}>
                                Quyền được cấp
                              </Text>
                            </Space>
                          </div>
                        )}
                      </Space>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          </Card>
            </div>
        </section>
      </div>
  );
}

export default RolePermission;